var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandDigitalOceanStyleBlack = function SvgBrandDigitalOceanStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    clipPath: "url(#svg_icon_BrandDigitalOceanStyleBlack__clip0_3952_114500)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.089 24v-4.297c4.548 0 8.08-4.511 6.333-9.299a6.42 6.42 0 0 0-3.832-3.833C8.802 4.837 4.29 8.356 4.29 12.904H.006C.006 5.654 7.018 0 14.62 2.374c3.317 1.044 5.968 3.682 7 7C23.993 16.988 18.351 24 11.088 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83 19.715H11.1v-4.272H6.83zm-3.293 3.292h3.292v-3.292H3.537zM.785 19.715h2.752v-2.752H.785z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandDigitalOceanStyleBlack__clip0_3952_114500"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandDigitalOceanStyleBlack);
export { ForwardRef as ReactComponent };